"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 341.53 328.28",
    children: [(0, jsx_runtime_1.jsx)("circle", {
      cx: "43.12",
      cy: "247.7",
      r: "14.55"
    }), (0, jsx_runtime_1.jsx)("circle", {
      cx: "89.87",
      cy: "247.7",
      r: "14.55"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M463.3,453.73H445.69V418h18.09a6.8,6.8,0,0,0,0-13.6H277.66a6.8,6.8,0,0,0,0,13.6h18.09v35.73H264.3V221.58h42.17V257h24.18v71.16l32.07,21.05V385a6.88,6.88,0,1,0,13.75,0V350.19l34.31-22V257H435V221.58h35.21V139.2H129.05v80.39a6.88,6.88,0,0,0,13.75,0V153H456.43v54.88H250.55v245.9H135.93a6.88,6.88,0,1,0,0,13.75H463.3a6.88,6.88,0,1,0,0-13.75ZM397,320.65l-20.56,13.2-6.08,3.91-7.67-5-18.32-12V257H397Zm24.19-99.07v21.63h-101V221.58ZM309.5,418H431.94v35.73H309.5Z",
      transform: "translate(-129.05 -139.2)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M159.42,356.58h72.25V238.33H159.42Zm13.75-104.5h44.75v90.75H173.17Z",
      transform: "translate(-129.05 -139.2)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M413.59,360.2l-28,28a6.18,6.18,0,0,0,8.74,8.74l28-28a6.19,6.19,0,0,0-8.75-8.75Z",
      transform: "translate(-129.05 -139.2)"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M316.84,360.2a6.18,6.18,0,0,0,0,8.75l28,28a6.18,6.18,0,0,0,8.75-8.74l-28-28A6.19,6.19,0,0,0,316.84,360.2Z",
      transform: "translate(-129.05 -139.2)"
    })]
  });
};

exports.default = Icon;